import { render, staticRenderFns } from "./TradeView.vue?vue&type=template&id=a25859ac&scoped=true"
import script from "./TradeView.vue?vue&type=script&lang=ts"
export * from "./TradeView.vue?vue&type=script&lang=ts"
import style0 from "./TradeView.vue?vue&type=style&index=0&id=a25859ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25859ac",
  null
  
)

export default component.exports